import { findById } from '@sleepstation/utils'
import { curry, pipe, prop } from 'ramda'

// TODO: Refactor this out by having renderList pass the object into
// `idFunc` as a second prop
// eslint-disable-next-line import/prefer-default-export
export const getKeyFromLinks = curry((links, id) =>
  pipe(findById(id), prop(`key`))(links)
)
